import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch, FaStar, FaRegStar } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
import { UserContext } from '../context/UserContext';

export default function RatingStars({ value, onChange }) {
  const [hoverValue, setHoverValue] = useState(undefined);

  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((num) => {
        const filled = hoverValue ? num <= hoverValue : num <= value;

        return (
          <span
            key={num}
            className="cursor-pointer"
            onClick={() => onChange(num)}
            onMouseEnter={() => setHoverValue(num)}
            onMouseLeave={() => setHoverValue(undefined)}
          >
            {filled ? (
              <FaStar className="w-8 h-8 text-yellow-400" />
            ) : (
              <FaRegStar className="w-8 h-8 text-gray-300" />
            )}
          </span>
        );
      })}
    </div>
  );
}

export function ReviewModal({ apartment, setApartmentReview, setShowReviewModal, getData }) {
  const {userProfile, logOutFunction} = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const {setTostMessage} = useContext(TostMessageContext);
  const [cookies] = useCookies();
  const [formFields, setFormFields] = useState({});

  const handleSubmit = async () => {
    if (rating === 0) {
      setTostMessage({
        messageType: 'error',
        message: 'Please select a star rating'
      })
      return;
    }
    const formData = new FormData();
    formData.append('rating', rating);
    formData.append('comment', comment);
    formData.append('apartment_id', apartment.apartment_id);
    formData.append('booking_reference', apartment.booking_reference);
    Object.entries(formFields).forEach(([key, value]) => {
      formData.append(key, value);
    });

    setLoading(true)
    try {
        const response = await axios.post(base_url + '/review-apartment.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                accountid: cookies?.userProfile?.main_id,
            },
        });
        if (response.data.code == 403) {
            logOutFunction()
        }
        if (response.data.status) {
            setTostMessage({
                messageType: 'success',
                message: response.data.message
            })
            getData();
            setRating(0);
            setComment("");
            setShowReviewModal(false);
            setApartmentReview({});
        } else {
        setTostMessage({
            messageType: 'error',
            message: response.data.message
        })
        }
        setLoading(false)
    } catch (error) {
        setLoading(false)
        setTostMessage({
            messageType: 'error',
            message: 'Network Error'
        })
    }
  };

  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 max-h-[80%] min-h-[100px] w-[85%] lg:w-[35%] mx-auto my-auto bg-white rounded-[15px] animate-scaleIn'>
                <div onClick={() => setShowReviewModal(false)} className='w-[80%] flex justify-end text-underline text-[#ff0000] cursor-pointer'>Cancel</div>
                    <a className='text-dark text-[20px] font-bold'>Review {apartment?.name}</a>
                    {/* Stars */}
                    <div className="my-5">
                        <RatingStars value={rating} onChange={setRating} />
                    </div>
                    <div className='overflow-y-auto w-[80%] mx-auto'>
                      <div className="flex flex-col w-full my-1">
                          <label className='font-semibold font-aileron-regular'>Staff</label>
                          <select
                            className="w-full mx-auto border p-2 rounded my-1"
                            onChange={(e) => setFormFields({...formFields, staff: e.target.value})}
                          >
                            <option value="">Choose an option</option>
                            <option>{'1'}</option>  
                            <option>{'2'}</option>
                            <option>{'3'}</option>
                            <option>{'4'}</option>
                            <option>{'5'}</option>       
                          </select>
                      </div>

                      <div className="flex flex-col w-full my-1">
                          <label className='font-semibold font-aileron-regular'>Facilities</label>
                          <select
                            className="w-full mx-auto border p-2 rounded my-1"
                            onChange={(e) => setFormFields({...formFields, facilities: e.target.value})}
                          >
                            <option value="">Choose an option</option>
                            <option>{'1'}</option>  
                            <option>{'2'}</option>
                            <option>{'3'}</option>
                            <option>{'4'}</option>
                            <option>{'5'}</option>       
                          </select>
                      </div>

                      <div className="flex flex-col w-full my-1">
                          <label className='font-semibold font-aileron-regular'>Cleanliness</label>
                          <select
                            className="w-full mx-auto border p-2 rounded my-1"
                            onChange={(e) => setFormFields({...formFields, cleanliness: e.target.value})}
                          >
                            <option value="">Choose an option</option>
                            <option>{'1'}</option>  
                            <option>{'2'}</option>
                            <option>{'3'}</option>
                            <option>{'4'}</option>
                            <option>{'5'}</option>       
                          </select>
                      </div>
                      <div className="flex flex-col w-full my-1">
                          <label className='font-semibold font-aileron-regular'>Comfort</label>
                          <select
                            className="w-full mx-auto border p-2 rounded my-1"
                            onChange={(e) => setFormFields({...formFields, comfort: e.target.value})}
                          >
                            <option value="">Choose an option</option>
                            <option>{'1'}</option>  
                            <option>{'2'}</option>
                            <option>{'3'}</option>
                            <option>{'4'}</option>
                            <option>{'5'}</option>       
                          </select>
                      </div>

                      <div className="flex flex-col w-full my-1">
                          <label className='font-semibold font-aileron-regular'>Location</label>
                          <select
                            className="w-full mx-auto border p-2 rounded my-1"
                            onChange={(e) => setFormFields({...formFields, location: e.target.value})}
                          >
                            <option value="">Choose an option</option>
                            <option>{'1'}</option>  
                            <option>{'2'}</option>
                            <option>{'3'}</option>
                            <option>{'4'}</option>
                            <option>{'5'}</option>       
                          </select>
                      </div>

                      <div className="flex flex-col w-full my-1">
                          <label className='font-semibold font-aileron-regular'>Value For Money</label>
                          <select
                            className="w-full mx-auto border p-2 rounded my-1"
                            onChange={(e) => setFormFields({...formFields, value: e.target.value})}
                          >
                            <option value="">Choose an option</option>
                            <option>{'1'}</option>  
                            <option>{'2'}</option>
                            <option>{'3'}</option>
                            <option>{'4'}</option>
                            <option>{'5'}</option>       
                          </select>
                      </div>

                      {/* Comment Box */}
                      <div className="flex flex-col w-full my-1">
                          <label className='font-semibold font-aileron-regular'>Leave a Comment</label>
                          <textarea
                          className="w-full my-1 mx-auto border border-gray-300 rounded-lg p-3 h-28 outline-none focus:border-blue-500"
                          placeholder={`Say something about your stay at ${apartment?.name}...(optional)`}
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                          />
                      </div>
                    </div>
                    {/* Buttons */}
                    <div className="flex justify-between mt-5">
                        <button
                            onClick={handleSubmit}
                            className="
                            bg-[#037684] text-white rounded-full font-semibold
                            px-8 py-3 transition hover:bg-primary
                            w-full md:w-auto md:self-center
                            "
                        >
                            Submit Review
                        </button>
                    </div>
                {loading ? (
                    <ClockLoader
                        color={'#212121'}
                        loading={loading}
                        size={25}
                        className='mt-3'
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                    ) : null
                }
            </div>  
        </div>
    )
}

